"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ErrorIcon;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @ts-ignore: Unreachable code error

function ErrorIcon() {
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "barring-management-error-message-icon"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      right: 2,
      bottom: 2
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Icon, {
    name: "error",
    group: "state",
    size: 3
  })));
}